export default __webpack_public_path__ + "static/media/m_session8__1.176edc43.png";